import barClusteredBarChart from "assets/images/chart-images/clustered-bar-chart.png";
import table from "assets/images/chart-images/table.png";

const timePeriodList = [
        { id: "STPR#-CC01t", name: "clustered-bar", chartImage: barClusteredBarChart, disabled: false },
        { id: "STPR#-T01t", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "STPR#-T02t", name: "table", chartImage: table, v2: "Row", disabled: false },
        { id: "STPR#-T20t", name: "table", chartImage: table, disabled: false },
];

export default timePeriodList;
